import React from 'react';

interface CarveOutRow {
  isCaseRate?: boolean;
}

/**
 * Case rate display
 */
export const CaseRateTemplate: React.FC<{ value: boolean }> = ({ value }) => (
  <span>{value ? 'Yes' : 'No'}</span>
);

// Template function for grid column
export const caseRateTemplate = (props: CarveOutRow) => (
  <CaseRateTemplate value={props.isCaseRate || false} />
);

export default CaseRateTemplate;
